<template>
  <div class="content4 content6 contentPage swiper-slide" :class="nowPage === 5 ? 'cartoon' : ''">
    <div class="animalNav" :style="{display: showNow === 0 ? 'flex' : 'none'}">
      <div class="leftTxtWrap">
        <img :src="txtImg" class="txtImg"/>
        <div class="heng"></div>
        <img :src="titleImg" class="titleImg"/>
        <div class="txtInfo">基干鸟类保留了一条由多块尾椎骨组成的长尾巴，代表了鸟类演化树上最原始的分支类型。热河生物群的基干鸟类一般大于其他古鸟类，尽管尾椎更多且比例更长，但其骨骼特征比生活在侏罗纪的始祖鸟稍显进步。根据最新研究成果表明热河生物群中的原始基干鸟类多数属于地栖类型，且主要以谷物和种子果实为食，并具有一定飞行能力。</div>
        <div class="btnWrap">
          <animalBtn 
            v-for="item in btnList" 
            :key="item.id" 
            :cnTitle='item.cnTitle' 
            :enTitle='item.enTitle'
            @click.native="changeShowAnimal(item.id)"
          ></animalBtn>
        </div>
      </div>
      <div class="rightImgWrap">
        <moveImg :imgSrc='rightAni' class="rightAni"></moveImg>
      </div>
    </div>

    <categoryAnimal 
      :animalType='confuciusornisAnimal.animalType' 
      :animalTypeEn='confuciusornisAnimal.animalTypeEn'
      :categoryTxt='confuciusornisAnimal.categoryTxt'
      :categoryInfoImg='confuciusornisAnimal.categoryInfoImg'
      :showList='confuciusornisAnimal.showList'
      @changeShowAnimal='changeShowAnimal'
      :show="showNow === 1"
    ></categoryAnimal>

    <categoryAnimal 
      :animalType='sapeornithidaeAnimal.animalType' 
      :animalTypeEn='sapeornithidaeAnimal.animalTypeEn'
      :categoryTxt='sapeornithidaeAnimal.categoryTxt'
      :categoryInfoImg='sapeornithidaeAnimal.categoryInfoImg'
      :showList='sapeornithidaeAnimal.showList'
      @changeShowAnimal='changeShowAnimal'
      :show="showNow === 2"
    ></categoryAnimal>
  </div>
</template>

<script>
import { swiperMixin } from '@/utils/mixin.js'

import txtImg from '@/assets/img/content6/txtImg.png'
import titleImg from '@/assets/img/content6/titleImg.png'
import rightAni from '@/assets/img/content6/rightAni.png'

import { btnList, confuciusornisAnimal, sapeornithidaeAnimal } from './data'


export default {
  mixins: [swiperMixin],
  data () {
    return {
      txtImg,
      titleImg,
      rightAni,
      showNow: 0, // 当前展示的是第几个
      btnList,
      confuciusornisAnimal, // 孔子鸟
      sapeornithidaeAnimal, // 会鸟科
    }
  },
  computed: {
    nowPage () {
      return this.$store.state.nowPage
    }
  },
  watch: {
    nowPage ( nowPage ) {
      if ( nowPage === 5 && this.showNow > 0 ) {
        this.showNow = 0
      }
    }
  },
}
</script>

<style lang="stylus" scoped>
@import '../../stylus/app.styl'
@import '../../stylus/animation.styl'
@import '../content4/content4.styl'
@import './content6.styl'
</style>